import { Navigate, Route, Routes } from "react-router-dom";

import { NoAccess, SubNav } from "@/app/Shell";
import { GATE, useSession } from "@/auth/session";
import { FleetCommandsPage } from "@/modules/fleet/CommandsPage";
import { FleetControlPage } from "@/modules/fleet/ControlPage";

/** Fleet — commanding assets. Its OWN module, and that is a correctness fix.
 *
 *  WHY IT MOVED OUT OF ASSET DATA. Dattatray: *"Asset data can be seen by many
 *  people but asset control shall be accessible to only a few!"* The
 *  permission model already said exactly that, and the UI contradicted it:
 *
 *      basic  company_admin   asset_data=True   fleet=False
 *      pro    company_admin   asset_data=True   fleet=True
 *
 *  `GATE_ASSET_DATA` is in every plan including BASIC; `GATE_FLEET` is PRO-only
 *  and `IMMOBILIZE` is narrower still. With Asset Control living inside the
 *  Asset Data module, a BASIC user SAW the tab and every button 403'd — the nav
 *  said yes while the server said no. Worse, the Fleet rail entry existed all
 *  along (`Shell.tsx`, `wired: false`) with a catalogue description reading
 *  "Live map and commands", so the right home was already named and empty.
 *
 *  THE MODULE GUARDS ITSELF, which no other module does — `App.tsx` mounts
 *  every module ungated and relies on the rail hiding what you cannot reach.
 *  That is fine for a read-only module and not fine here: the rail is
 *  cosmetic, and a TYPED `/fleet/control` would otherwise render the whole
 *  page to a BASIC account and let it discover the answer from a row of 403s.
 *  `require_cap(GATE_FLEET)` on the router is still the enforcement; this is
 *  what stops the console asking.
 *
 *  BOTH TABS ARE UNGATED BEYOND THE MODULE, deliberately. Reading what has
 *  been commanded is not commanding: a fleet operator who may open Fleet but
 *  not immobilise still needs to see that somebody did. The WRITE controls on
 *  both pages sit behind `CAP.IMMOBILIZE` individually — which is why neither
 *  page is gated as a whole.
 */
export function FleetModule() {
  const { can } = useSession();
  if (!can(GATE.FLEET)) return <NoAccess label="Fleet" />;
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <SubNav
          base="/fleet"
          tabs={[
            { path: "commands", label: "Commands" },
            { path: "control", label: "Asset Control" },
          ]}
        />
        <div style={{ marginLeft: "auto", paddingBottom: 9, paddingRight: 20 }}>
        </div>
      </div>
      <Routes>
        <Route path="commands" element={<FleetCommandsPage />} />
        <Route path="control" element={<FleetControlPage />} />
        {/* COMMANDS IS THE LANDING TAB. Asset Control needs an asset to be
            about; arriving at /fleet with no query would show an empty picker
            and look broken. The map's popups and the log's rows deep-link
            straight to /fleet/control?asset=… , which is how that page is
            meant to be reached. */}
        <Route path="*" element={<Navigate to="commands" replace />} />
      </Routes>
    </>
  );
}
